import { barnToolsApi } from './base';
import { IAssignedUsers } from './types';

export const assignmentsApi = barnToolsApi
  .enhanceEndpoints({
    addTagTypes: ['gatewayAssignments', 'gatewayGroupAssignments'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getUsersForGateway: builder.query<IAssignedUsers, string>({
        query: (serialNumber) => {
          return {
            url: `gateways/${serialNumber}/users`,
          };
        },
        providesTags: ['gatewayAssignments'],
      }),
      assignUserToGateway: builder.mutation({
        query: (args: {
          userId: string;
          gatewaySerial: string;
          roleId: number;
        }) => {
          return {
            url: `gateways/${args.gatewaySerial}/users`,
            method: 'POST',
            body: {
              userId: args.userId,
              roleId: args.roleId,
            },
          };
        },
        invalidatesTags: ['gatewayAssignments'],
      }),
      updateUserGatewayRole: builder.mutation({
        query: (args: {
          userId: string;
          gatewaySerial: string;
          roleId: number;
        }) => {
          return {
            url: `gateways/${args.gatewaySerial}/users/${args.userId}`,
            method: 'PUT',
            body: {
              roleId: args.roleId,
            },
          };
        },
        invalidatesTags: ['gatewayAssignments'],
      }),
      unassignUserToGateway: builder.mutation({
        query: (args: { userId: string; gatewaySerial: string }) => {
          return {
            url: `gateways/${args.gatewaySerial}/users/${args.userId}`,
            method: 'DELETE',
          };
        },
        invalidatesTags: ['gatewayAssignments'],
      }),
      getUsersForGatewayGroup: builder.query<IAssignedUsers, string>({
        query: (gatewayGroupId) => {
          return {
            url: `gatewayGroups/${gatewayGroupId}/users`,
          };
        },
        providesTags: ['gatewayGroupAssignments'],
      }),
      assignUserToGatewayGroup: builder.mutation({
        query: (args: {
          userId: string;
          gatewayGroupid: string;
          roleId: number;
        }) => {
          return {
            url: `gatewayGroups/${args.gatewayGroupid}/users`,
            method: 'POST',
            body: {
              userId: args.userId,
              roleId: args.roleId,
            },
          };
        },
        invalidatesTags: ['gatewayGroupAssignments'],
      }),
      updateUserGatewayGroupRole: builder.mutation({
        query: (args: {
          userId: string;
          gatewayGroupid: string;
          roleId: number;
        }) => {
          return {
            url: `gatewayGroups/${args.gatewayGroupid}/users/${args.userId}`,
            method: 'PUT',
            body: {
              roleId: args.roleId,
            },
          };
        },
        invalidatesTags: ['gatewayGroupAssignments'],
      }),
      unassignUserToGatewayGroup: builder.mutation({
        query: (args: { userId: string; gatewayGroupId: string }) => {
          return {
            url: `gatewayGroups/${args.gatewayGroupId}/users/${args.userId}`,
            method: 'DELETE',
          };
        },
        invalidatesTags: ['gatewayGroupAssignments'],
      }),
    }),
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAssignUserToGatewayMutation,
  useGetUsersForGatewayQuery,
  useUnassignUserToGatewayMutation,
  useUpdateUserGatewayRoleMutation,
  useAssignUserToGatewayGroupMutation,
  useGetUsersForGatewayGroupQuery,
  useUnassignUserToGatewayGroupMutation,
  useUpdateUserGatewayGroupRoleMutation,
} = assignmentsApi;
